import moment from "moment";
import { useMainStore } from "../store";
import { yearsToWeeks } from "../uitls";

export const TODAY = moment();
export const BLOCK_SIZE = 260;

export const useConfig = () => {
  const { yearsToLive, dateOfBirth } = useMainStore();
  const weeksToLive = yearsToWeeks(yearsToLive);

  return {
    today: TODAY,
    yearsToLive,
    weeksToLive,
    weeksDiff: TODAY.diff(dateOfBirth, "weeks"),
    calendarSize: weeksToLive / BLOCK_SIZE,
  };
};
